import { useEffect } from 'react';
import useModalContext from 'components/context/modal';
import useInterval from 'components/hooks/useInterval';

import useUserContext from '../context/user';

/**
 * UseApi hook works with AppContext for loading and error state.
 *
 * @param {void} callback method with accessToken as a param
 * @param {array} deps array of deps
 */
const useApi = (callback, deps = []) => {
  const modalContext = useModalContext();
  const userContext = useUserContext();

  useEffect(() => {
    (async () => {
      modalContext.setLoading(true);

      try {
        await callback(userContext.accessToken);
      } catch (error) {
        // TODO
        console.log(error);
      }

      modalContext.setLoading(false);
    })();
  }, deps);
};

export const useApiHandler = handle => {
  const modalContext = useModalContext();
  const userContext = useUserContext();

  return async (...args) => {
    modalContext.setLoading(true);

    let value;
    try {
      value = await handle(...args, userContext.accessToken);
    } catch (error) {
      // TODO
      console.log(error);
    }

    modalContext.setLoading(false);

    return value;
  };
};

export default useApi;
